import styled from 'styled-components';
import colors from 'Styles/colors';
import { ReactComponent as _Warning } from 'Images/warning-delete.svg';
import { slideIn } from 'Styles/effects';
import { Accept } from '../Button/styled';

export const ModalContent = styled.div`
  padding: 34px;
  box-shadow: 0 2px 50px 0 rgba(0, 0, 0, 0.24);
  border-radius: 2px;
  border-top: 10px solid ${colors.softBlue};
  background: ${({ theme }) => theme.backgrounds.modal};
  width: 505px;
  ${slideIn}
`;
ModalContent.displayName = 'ModalContent';

export const ModalTitle = styled.div`
  display: flex;
  margin-bottom: 16px;
`;
ModalTitle.displayName = 'ModalTitle';

export const Warning = styled(_Warning)`
  align-self: center;
  & > g{
    fill: ${({ theme }) => theme.icons.actionBar.color};
  }
  & > g > g{
    fill: ${({ theme }) => theme.icons.actionBar.color};
  }

`;
Warning.displayName = 'Warning';

export const Title = styled.div`
  color: ${({ theme }) => theme.text.modalTitle};
  font-weight: 600;
  font-size: 21.5px;
  margin-left: 13px;
`;
Title.displayName = 'Title';

export const ModalBody = styled.div`
  & > *:not(:last-child) {
    margin-right: 4px;
  };
`;
ModalBody.displayName = 'ModalBody';

export const BodyText = styled.div`
  color: ${colors.grey19};
  font-size: 12.5px;
  font-weight: 300;
  display: inline-block;
`;
BodyText.displayName = 'BodyText';

export const BlueText = styled(BodyText)`
  color: ${colors.softBlue};
`;
BlueText.displayName = 'BlueText';

export const ButtonsContainer = styled.div`
display: flex;
justify-content: space-between;
margin-top: 34px;
width: 190px;
margin-left: auto;
`;
ButtonsContainer.displayName = 'ButtonsContainer';

export const ConfirmButton = styled(Accept)`
`;
ConfirmButton.displayName = 'ConfirmButton';

// export const CancelButton = styled(Cancel)`
//   margin-right: 10px;
// `;
// CancelButton.displayName = 'CancelButton';

const Button = styled.button`
  width: 89px;
  height: 38px;
  border-radius: 2px;
  float: right;
  font-size: 14px;
  font-weight: 500;
`;

export const CancelButton = styled(Button)`
  margin-right: 10px;
  margin-left: auto;
  border: solid 1px ${({ theme }) => theme.buttons.custom.border};
  color: ${({ theme }) => theme.buttons.custom.color};
  background-color: ${({ theme }) => theme.buttons.custom.background};
  margin-right: 8px;
  float: none;
`;
CancelButton.displayName = 'CancelButton';
